<template>
  <div
    class="ll-amount-card"
    :class="{clickable:isClickable}"
    @click="$_onClick()"
  >
    <div
      v-if="hasButton"
      class="ll-amount-card_button"
    >
      <WsTextButton001
        primary
        font-size-lg
        no-padding
        :leading-icon="buttonIcon"
        @click="$_buttonClick()"
      >
        {{ buttonText }}
      </WsTextButton001>
    </div>
    <div
      v-if="title"
      class="ll-amount-card__title-wrap"
    >
      <div
        class="ll-add-member-card_title-label"
        :style="{left:`-${labelWidth + 4}px`}"
      >
        <i
          v-if="icon"
          class="ll-add-member-card_label-icon"
          :class="icon"
          :style="{color:_labelColor}"
        />
        <div
          class="ll-add-member-card_label"
          :style="{width:`${labelWidth}px`,height:`${labelHeight}px`,borderRadius:`${labelBorderRadius}px`,backgroundColor:_labelColor,boxShadow:`0 0 4px 0 ${_labelBoxShadow}`,backgroundImage:_labelBackgroundImage}"
        />
      </div>
      <p class="ll-add-member-card_title">
        {{ title }}
      </p>
    </div>
    <div
      class="ll-amount-card__content"
      :class="{'mt-sm':contentText}"
    >
      <p
        v-if="contentText"
        class="ll-amount-card__content-text"
      >
        {{ contentText }}
      </p>
      <p
        v-else
        class="ll-amount-card__content-number"
      >
        {{ isClickable ? number : '-' }}
        <span
          v-if="unit && isClickable"
          class="ll-amount-card__content-unit"
        >{{ unit }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlAmountCard",
  props: {
    contentText: {
      type: String,
      default: "",
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    buttonIcon: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    isClickable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    number: {
      type: Number,
      default: 0,
    },
    unit: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    labelWidth: {
      type: Number,
      default: 0,
    },
    labelHeight: {
      type: Number,
      default: 0,
    },
    labelColor: {
      type: String,
      default: "",
    },
    labelBorderRadius: {
      type: Number,
      default: 0,
    },
    labelColorStatus: {
      type: Array,
      default() {
        return [];
      },
    },
    labelBoxShadowColor: {
      type: String,
      default: "",
    },
    backgroundImg: {
      type: String,
      default: "",
    },
    colorType: {
      type: String,
      default: "",
    },
  },
  computed: {
    _labelColor() {
      if (this.labelColorStatus.length === 0) return this.labelColor;
      let selectColor = this.labelColorStatus.find(
        (status) => status.type === this.colorType
      );
      return selectColor && selectColor.color ? selectColor.color : "";
    },
    _labelBoxShadow() {
      if (this.labelColorStatus.length === 0) return this.labelBoxShadowColor;
      let selectColor = this.labelColorStatus.find(
        (status) => status.type === this.colorType
      );
      return selectColor && selectColor.boxShadowColor
        ? selectColor.boxShadowColor
        : "";
    },
    _labelBackgroundImage() {
      if (this.labelColorStatus.length === 0) return this.backgroundImg;
      let selectColor = this.labelColorStatus.find(
        (status) => status.type === this.colorType
      );
      return selectColor && selectColor.backgroundImg
        ? selectColor.backgroundImg
        : "";
    },
  },
  methods: {
    $_onClick() {
      this.$emit("card-click");
    },
    $_buttonClick() {
      this.$emit("button-click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-amount-card";
</style>